import { render, staticRenderFns } from "./collectPendingInfo.vue?vue&type=template&id=fcedb79a&scoped=true&"
import script from "./collectPendingInfo.vue?vue&type=script&lang=tsx&"
export * from "./collectPendingInfo.vue?vue&type=script&lang=tsx&"
import style0 from "./collectPendingInfo.vue?vue&type=style&index=0&id=fcedb79a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcedb79a",
  null
  
)

export default component.exports